import { useTranslate } from "src/i18n";

export const useProductPageTranslate = () => {
  const { t } = useTranslate();

  return {
    noMoreProducts: t(
      "product_page.product_list.no_more",
      "Вы просмотрели все продукты",
    ),
    filters: t("product_page.product_list.filters", "Фильтры"),
    search: t("product_page.product_list.search.placeholder", "Поиск"),
    cards: t(
      "product_page.product_list.search.actions.tooltip.cards",
      "Карточки",
    ),
    table: t(
      "product_page.product_list.search.actions.tooltip.table",
      "Таблица",
    ),
    viewSelection: t(
      "product_page.product_list.filters.view_selection",
      "Просмотр выборки",
    ),
    refreshingData: t(
      "product_page.product_list.refreshing_data",
      "Обновление данных...",
    ),
    productsCountFound: t(
      "product_page.product_list.products_count_found",
      "Найдено",
    ),
    selectionSaveErrorTitle: t(
      "product_page.product_list.selection_save_error.title",
      "Отметки не сохранились",
    ),
    selectionSaveErrorContent: t(
      "product_page.product_list.selection_save_error.content",
      "Список отмеченных товаров вернулся к прежнему состоянию",
    ),
    selectionSaveRetry: t(
      "product_page.product_list.selection_save_error.retry",
      "Повторить",
    ),
    brandLabel: t("product_page.filters.brand.label", "Бренд"),
    brandPlaceholder: t(
      "product_page.filters.brand.placeholder",
      "Выберите бренд",
    ),
    categoryLabel: t("product_page.filters.category.label", "Категория"),
    categoryPlaceholder: t(
      "product_page.filters.category.placeholder",
      "Выберите категорию",
    ),
    productSamplesLabel: t(
      "product_page.filters.product_samples.label",
      "Выборка товаров",
    ),
    sourcesLabel: t("product_page.filters.sources.label", "Источник данных"),
    sourcesPlaceholder: t(
      "product_page.filters.sources.placeholder",
      "Выберите источник",
    ),
    includeCustomLabel: t(
      "product_page.filters.includeCustom.label",
      "Кастомные товары",
    ),
    includeCustomPlaceholder: t(
      "product_page.filters.includeCustom.placeholder",
      "Выберите фильтр",
    ),
    sortLabel: t("product_page.filters.sort.label", "Сортировка"),
    genderLabel: t("product_page.filters.gender.label", "Пол"),
    genderPlaceholder: t(
      "product_page.filters.gender.placeholder",
      "Выберите пол",
    ),
    excludeSamplesCustomLabel: t(
      "product_page.filters.excludeSamples.label",
      "Исключить из поиска",
    ),
    excludeSamplesPlaceholder: t(
      "product_page.filters.excludeSamples.placeholder",
      "Выборки",
    ),
    currencyLabel: t("product_page.filters.currency.label", "Валюта"),
    currencyPlaceholder: t(
      "product_page.filters.currency.placeholder",
      "Выберите валюту",
    ),
    priceRangeLabel: t("product_page.filters.priceRange.label", "Цена"),
    priceRangeMinPlaceholder: t(
      "product_page.filters.priceRange.minPrice.placeholder",
      "Мин. Цена",
    ),
    priceRangeMaxPlaceholder: t(
      "product_page.filters.priceRange.maxPrice.placeholder",
      "Макс. Цена",
    ),
    createdAtRangeLabel: t(
      "product_page.filters.createdAtRange.label",
      "Дата добавления",
    ),
    createdAtRangeFromPlaceholder: t(
      "product_page.filters.createdAtRange.from.placeholder",
      "С даты",
    ),
    createdAtRangeToPlaceholder: t(
      "product_page.filters.createdAtRange.to.placeholder",
      "По дату включительно",
    ),
    viewAllSelectedButton: t(
      "product_page.filters.view_all_selected.button",
      "Показать выбранные товары",
    ),
    fillProductSelectionButton: t(
      "product_page.filters.fill_product_selection.button",
      "Заполнить по фильтрам",
    ),
  };
};
